import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './popup.css';
import onClickOutside from 'react-onclickoutside';

const Popup = onClickOutside(props => {
  return (
    <div className={cx('popup', { opened: props.opened })}>
      <div className="triangle" />
      <div className="popup-content">
        <ul>
          {props.items.map((item, idx) => {
            return (
              <li
                key={idx}
                onClick={() => {
                  props.onClickItem(item);
                }}
              >
                {item}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
});

Popup.defaultProps = {
  items: [],
  opened: false,
  onClickItem: () => {},
};

Popup.propTypes = {
  items: PropTypes.array,
  opened: PropTypes.bool,
  onClickItem: PropTypes.func,
};

export default Popup;



// WEBPACK FOOTER //
// ./src/app/component/popup/popup.js